import React, { useContext, useEffect, useState } from "react";
import { Container } from "reactstrap";
import MenuRegular from "../components/menu/MenuRegular";
import PromoCarousel from "../components/menu/PromoCarousel";
import MenuPromo from "../components/menu/MenuPromo";
import MenuVertical from "../components/menu/MenuVertical";
import { useLocation } from "react-router-dom";
import { PublicContext } from "../components/PublicContext"
import LocationOrderType from "../components/LocationOrderType";
import dayjs from 'dayjs';

export default function Menu() {
    const { stores, setMenuUrl, selectedStore } = useContext(PublicContext);
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    // Parse the query parameters from the location search string
    const queryParams = new URLSearchParams(location.search);
    // Get the values of storeCode and storeId from the query parameters
    const storeCode = queryParams.get("storeCode") ?? null;
    const storeId = queryParams.get("storeId") ?? null;
    const deliveryOrPickUp = queryParams.get("deliveryOrPickUp") ?? null;
    const address = queryParams.get("address") ?? null;
    const [urlDecoded, setUrlDecoded] = useState(false);

    if (sessionStorage.getItem("scheduleDate") == null || sessionStorage.getItem("scheduleTime") == null) {
        sessionStorage.setItem("scheduleDate", dayjs().format('MMM-DD'));
        sessionStorage.setItem("scheduleTime", "now");
    }

    useEffect(() => {
        //console.log("Menu useEffect");
        if (storeCode) {
            //console.log(stores);
            //console.log(storeCode);
            let findStoreId = stores.find(s => s.storeCode === storeCode).storeId;
            //console.log("findStoreId: " + findStoreId);
            sessionStorage.setItem("selectedStore", JSON.stringify({ storeCode: storeCode, storeId: findStoreId }));
            setUrlDecoded(true);
            sessionStorage.setItem("menuUrl", queryParams);
            setMenuUrl(queryParams);
        }
        if (storeId) {
            //console.log(storeId);
            let findStoreCode = stores.find(s => s.storeId == storeId).storeCode;
            //console.log("findStoreCode: " + findStoreCode);
            sessionStorage.setItem("selectedStore", JSON.stringify({ storeCode: findStoreCode, storeId: storeId }));
            setUrlDecoded(true);
            sessionStorage.setItem("menuUrl", queryParams);
            setMenuUrl(queryParams);
            setLoading(false);
            selectedStore.current = { storeCode: findStoreCode, storeId: storeId };
        }
        //sessionStorage.setItem("deliveryOrPickUp", "delivery");
        //if (deliveryOrPickUp) {
        //    console.log("setdeliveryorpickup");
        //    sessionStorage.setItem("deliveryOrPickUp", deliveryOrPickUp);
        //}
        //if (address) {
        //    console.log("setaddress");
        //    sessionStorage.setItem("selectedAddress", address);
        //}

        //if (
        //    sessionStorage.getItem("selectedStore") !== null
        //    && sessionStorage.getItem("deliveryOrPickUp") == null
        //    && !loading
        //) {
        //    console.log("set modal visible");
        //    setModalVisible(true);
        //}
        //else {
        //    setModalVisible(false);
        //}
    }, []);

    return (
        <div>
            <Container tag="main">
                {loading && !urlDecoded ?
                    <></>
                    :
                    <MenuVertical />
                }
                {/*<LocationOrderType />*/}
            </Container>
        </div>
    );
}